import { isElectron } from '../../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { WebAutocomplete } from './WebAutocomplete/WebAutocomplete';
import { KioskAutocomplete } from './KioskAutocomplete/KioskAutocomplete';
import { AutocompleteProps } from './Autocomplete.types';
import { KeyboardLayouts } from '../../../SimpleKeyboard/Layout';

const Autocomplete = <T,>({
    id,
    title,
    label,
    ariaLabel,
    labelClass,
    disabled,
    inputValue,
    options,
    onOptionSelected,
    getOptionLabel,
    renderOption,
    forceBottomPopper,
    filterOptions,
    clearOnBlur = false,
    keyboardLayout = KeyboardLayouts.Alphanumeric,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    shiftAfterSpace = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
}: AutocompleteProps<T>) => {
    return isElectron() ? (
        <KioskAutocomplete
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            labelClass={labelClass}
            disabled={disabled}
            inputValue={inputValue}
            options={options}
            filterOptions={filterOptions}
            onOptionSelected={onOptionSelected}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            forceBottomPopper={forceBottomPopper}
            clearOnBlur={clearOnBlur}
            keyboardLayout={keyboardLayout}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            shiftAfterSpace={shiftAfterSpace}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
        />
    ) : (
        <WebAutocomplete
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            labelClass={labelClass}
            disabled={disabled}
            inputValue={inputValue}
            options={options}
            filterOptions={filterOptions}
            onOptionSelected={onOptionSelected}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            forceBottomPopper={forceBottomPopper}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
        />
    );
};

export default Autocomplete;